export default "__VITE_ASSET__7l0gn9a6__"